import {Component, Injector} from '@angular/core';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {CommunicationApiService} from '../../../../../Services/Api/Communication/communication-api.service';
import {CommunicationFilters} from '../../../../../Models/Communication/communication-filters.model';
import {CommunicationDto} from '../../../../../Models/Communication/communication.interface';
import {CommunicationTypesEnum} from '../../../../../Shared/Enum/communication-types.enum';

@Component({
  selector: 'app-pendents-breakdowns-widget',
  templateUrl: './pendents-breakdowns-widget.component.html',
  styleUrls: ['./pendents-breakdowns-widget.component.scss'],
  standalone: false
})
export class PendentsBreakdownsWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 8;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected communicationService: CommunicationApiService,
  ) {
    super(injector, communicationService);
  }


  /**
   * Obtener las averías pendientes
   *
   */
  override setData(data: CommunicationDto[]) {
    this.data = data.filter((item) => !item.cerrado && item.id_subtipo === CommunicationTypesEnum.breakdowns)?.length;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const filters: CommunicationFilters = new CommunicationFilters();
    filters.id_local = this.widgetsManager.filters?.local.id || 0;

    return this.communicationService.getCommunications(filters, false);
  }

}
